import React from "react";
import { Phase } from "helpers/app";
import { Routing } from "helpers/routing";
import { useParams } from "react-router-dom";
import MatchDatasourceIdentifierContext from "./MatchDatasourceIdentifier.context";
import Detail from "./_Detail";
import Select from "./_Select";

const MatchDatasourceIdentifier: React.FC<Phase.Props> = (p) => {
  const params = useParams<Routing.MatchDatasourceIdentifierParams>()

  return (
    <MatchDatasourceIdentifierContext.Provider value={{ params: params }}>
      {p.phase === 'select' && <Select />}
      {p.phase === 'detail' && <Detail />}
    </MatchDatasourceIdentifierContext.Provider>
  )
}

export default MatchDatasourceIdentifier
